<template>
  <empty-state-card
    v-if="notValidContractMessage"
    icon="close"
    :message="notValidContractMessage"
  ></empty-state-card>
  <div v-else>
    <banner
      v-if="!mobile"
      :bannerDefaultImgs="config.images.bannerDefault"
      :bannerDefaultTitle="getBannerTitle"
      :bannerDefaultDescription="units.length > 1 ? bannerText : ''"
    ></banner>
    <screen-loading v-if="loadingApp"></screen-loading>
    <div class="select-unit" v-else-if="units.length > 0">
      <div class="select-unit__title">{{ bannerText }}</div>
      <div
        class="select-unit__unit"
        :key="i"
        v-for="(unitObj, i) in units"
        @click="selectUnit(unitObj)"
      >
        <div
          v-if="getLogoSource(unitObj.product.code)"
          class="select-unit__unit_logo"
          :style="{
            background: `url('${getLogoSource(unitObj.product.code)}')`,
            backgroundSize: 'contain'
          }"
        />
        <div class="select-unit__unit__text">
          <div class="select-unit__unit__text__product">
            {{ unitObj.product.title }}
          </div>
          <div class="select-unit__unit__text__unit-block">
            {{ unitObj.block.title }} - Unidade {{ unitObj.unitCodeClean }}
          </div>
        </div>
        <v-btn flat class="select-unit__unit__btn">
          <span>{{ selectProduct }}</span>
          <i class="bexsicon-right" />
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../utils/bus';
import { UNIT, CONFIG, IFRAME } from '../utils/constants';
import Banner from '@/components/Banner';
import ScreenLoading from '@/components/loaders/ScreenLoading';
import EmptyStateCard from '@/components/layout/EmptyStateCard';
import handlebars from '../services/handlebars';
export default {
  name: 'syndicSelectProduct',
  components: {
    Banner,
    ScreenLoading,
    EmptyStateCard
  },
  computed: {
    config() {
      return this.$store.getters[CONFIG.GET];
    },
    getBannerTitle() {
      var config = this.config;
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? config.texts.syndicBannerTitle
        : config.texts.bannerTitle;
    },
    selectProduct() {
      return this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'Selecione esse empreendimento'
        : 'Selecione essa unidade';
    }
  },
  created() {
    if (this.units.length === 0) {
      this.getContracts();
    } else if (this.units.length === 1) {
      this.selectUnit(this.units[0]);
    }
  },
  data() {
    return {
      bannerText: this.$store.getters[UNIT.GET_IS_SYNDIC]
        ? 'Qual empreendimento você gostaria de consultar ?'
        : 'Qual unidade você gostaria de consultar ?',
      notValidContractMessage: ''
    };
  },
  methods: {
    selectUnit(unitObj) {
      this.$store.dispatch(UNIT.SELECT, unitObj);
      this.$router.push({ name: 'home' });
    },

    getLogoSource(code) {
      try {
        const data = this.$store.getters[IFRAME.GET_DATA];
        if (!data) {
          return '';
        }

        const mask = data.logoMask;
        if (code) {
          data.code = code;
        }
        const template = handlebars.compile(mask);
        const url = template(data);
        return url;
      } catch (error) {
        if (process.env.NODE_ENV !== 'production') {
          console.info(error.toString());
        }
      }
    },
    async getContracts() {
      try {
        console.warn('getContracts syndic');
        // TODO Check if make sense
        const url = `${process.env.AUTH_API_URL}/user/getContracts`;
        const query = { username: this.user.username, onlyValid: 1 };
        const result = await this.requestService(url, 'GET', {
          params: query,
          localErrorHandling: true
        }).catch(err => {
          if (err.data.message === 'This user does not have a valid contract') {
            this.notValidContractMessage =
              'Este usuário não possui nenhum contrato ativo.';
          } else {
            bus.$emit('snackbar:open', {
              text: this.enums.responses.error,
              color: 'red'
            });
          }
          return [];
        });
        this.$store.commit(UNIT.MUTATE, result);
        if (this.units.length === 1) this.selectUnit(this.units[0]);
      } catch (err) {
        console.error(err);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/breakpoint';
.select-unit {
  &__title {
    padding: 1em;
    font-weight: var(--font-weight);
    color: var(--light-dark-color);
    font-size: 1.2em;

    @include breakpoint(not-mobile) {
      display: none;
    }
  }

  &__unit {
    width: 80%;
    margin: 0 auto;
    padding: 1em 0;
    display: flex;
    border-bottom: 1px solid #eeecec;
    cursor: pointer;

    &_logo {
      background-size: contain !important;
      height: 70px;
      width: 70px;
      margin: auto 8px;
    }

    &__text {
      flex: 0.8;
      padding: 0 1em;
      font-weight: var(--font-weight);
      color: var(--light-dark-color);
      font-size: 1.1em;
      margin: auto;
      @include breakpoint(mobile) {
        padding: 0;
        flex: 0.9;
        font-size: 1em;
      }
    }

    &__btn {
      flex: 0.2 !important;
      font-weight: 400;
      font-size: 1em;
      color: var(--brand-color) !important;
      margin: auto;
      @include breakpoint(mobile) {
        flex: 0.1;
      }

      span {
        @include breakpoint(mobile) {
          display: none;
        }
      }

      i {
        font-weight: 900;
        font-size: 0.7em;
        padding: 0.5em;
        margin: 0 1em;
        border: 1.4px solid;
        border-radius: 20px;

        @include breakpoint(mobile) {
          font-size: 1.2em;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/SyndicSelectProduct.vue